import React from 'react';

export function Wordmark({ size = 18, brand, accent }) {
  return (
    <span className="sp-wm" style={{ fontSize: size, lineHeight: 1 }}>
      <span className="sp-wm-brand" dangerouslySetInnerHTML={{ __html: brand || 'SIENGE' }} />
      <span className="sp-wm-accent" dangerouslySetInnerHTML={{ __html: accent || 'PAY' }} />
    </span>
  );
}
